const Colors = Object.freeze({
  light: {
    base: {
      b_1: {
        color: '#FAF9FD'
      },
      b_2: {
        color: '#FFFFFF'
      }
    },
    primary: {
      default: {
        color: 'rgba(161, 116, 254, 1)'
      },
      p_90: {
        color: 'rgba(161, 116, 254, 0.9)'
      },
      p_80: {
        color: 'rgba(161, 116, 254, 0.8)'
      },
      p_70: {
        color: 'rgba(161, 116, 254, 0.7)'
      },
      p_60: {
        color: 'rgba(161, 116, 254, 0.6)'
      },
      p_50: {
        color: 'rgba(161, 116, 254, 0.5)'
      },
      p_40: {
        color: 'rgba(161, 116, 254, 0.4)'
      },
      p_30: {
        color: 'rgba(161, 116, 254, 0.3)'
      },
      p_20: {
        color: 'rgba(161, 116, 254, 0.2)'
      },
      p_10: {
        color: 'rgba(161, 116, 254, 0.1)'
      }
    },
    secondary: {
      default: {
        color: 'rgba(245, 26, 175, 1)'
      },
      p_90: {
        color: 'rgba(245, 26, 175, 0.9)'
      },
      p_80: {
        color: 'rgba(245, 26, 175, 0.8)'
      },
      p_70: {
        color: 'rgba(245, 26, 175, 0.7)'
      },
      p_60: {
        color: 'rgba(245, 26, 175, 0.6)'
      },
      p_50: {
        color: 'rgba(245, 26, 175, 0.5)'
      },
      p_40: {
        color: 'rgba(245, 26, 175, 0.4)'
      },
      p_30: {
        color: 'rgba(245, 26, 175, 0.3)'
      },
      p_20: {
        color: 'rgba(245, 26, 175, 0.2)'
      },
      p_10: {
        color: 'rgba(245, 26, 175, 0.1)'
      }
    },
    tertiary: {
      default: {
        color: '#516FFF'
      },
      p_90: {
        color: 'rgba(82, 112, 255, 0.9)'
      },
      p_80: {
        color: 'rgba(82, 112, 255, 0.8)'
      },
      p_70: {
        color: 'rgba(82, 112, 255, 0.7)'
      },
      p_60: {
        color: 'rgba(82, 112, 255, 0.6)'
      },
      p_50: {
        color: 'rgba(82, 112, 255, 0.5)'
      },
      p_40: {
        color: 'rgba(82, 112, 255, 0.4)'
      },
      p_30: {
        color: 'rgba(82, 112, 255, 0.3)'
      },
      p_20: {
        color: 'rgba(82, 112, 255, 0.2)'
      },
      p_10: {
        color: 'rgba(82, 112, 255, 0.1)'
      }
    },
    neutral: {
      n_1: {
        color: '#2C2934'
      },
      n_2: {
        color: '#6B7188'
      },
      n_3: {
        color: '#5A6270'
      },
      n_4: {
        color: '#9EA3B6'
      },
      n_5: {
        color: '#BEC2C8'
      },
      n_6: {
        color: '#D2D2DA'
      },
      n_7: {
        color: '#DADCE5'
      },
      n_8: {
        color: '#EFEDF2'
      },
      n_9: {
        color: '#F4F4F5'
      },
      n_10: {
        color: '#F4F6F9'
      },
      white: {
        color: '#FFFFFF'
      },
      black: {
        color: '#000000'
      }
    },
    accents: {
      a_1: {
        default: {
          color: '#5797F8'
        },
        hover: {
          color: '#57B6F8'
        },
        active: {
          color: '#437ED7'
        },
        disabled: {
          color: '#9EC5FF'
        }
      },
      a_2: {
        default: {
          color: '#376AFE'
        },
        hover: {
          color: '#1B55FF'
        },
        active: {
          color: '#2E55C7'
        },
        disabled: {
          color: '#8AA8FF'
        }
      },
      a_3: {
        default: {
          color: '#F76294'
        },
        hover: {
          color: '#FF4785'
        },
        active: {
          color: '#EB3B76'
        },
        disabled: {
          color: '#FF8DB3'
        }
      },
      a_4: {
        default: {
          color: '#84EB86'
        },
        hover: {
          color: '#45F248'
        },
        active: {
          color: '#3BDD3E'
        },
        disabled: {
          color: '#9EEE9F'
        }
      },
      a_5: {
        default: {
          color: '#FFC500'
        },
        hover: {
          color: '#FFA200'
        },
        active: {
          color: '#F99E01'
        },
        disabled: {
          color: '#FFDC65'
        }
      },
      a_6: {
        default: {
          color: '#E74B4B'
        },
        hover: {
          color: '#E86364'
        },
        active: {
          color: '#DF6167'
        },
        disabled: {
          color: '#F58181'
        }
      },
      a_7: {
        default: {
          color: '#FFCE6E'
        },
        hover: {
          color: '#FFC561'
        },
        active: {
          color: '#FAD372'
        },
        disabled: {
          color: '#FFDFA0'
        }
      }
    },
    actions: {
      primary: {
        default: {
          color: '#8A51FF'
        },
        deep: {
          color: '#8A51FF'
        },
        shallow: {
          color: '#8A51FF'
        },
        hover: {
          color: '#7A38FF',
          p_10: {
            color: 'rgba(122, 56, 255, 0.1)'
          }
        },
        active: {
          color: '#691FFF',
          p_20: {
            color: 'rgba(105, 31, 255, 0.2)'
          }
        },
        disabled: {
          color: '#CFB8FF'
        },
        inverted: {
          color: '#FFFFFF'
        },
        visited: {
          color: '#8A51FF'
        }
      },
      secondary: {
        default: {
          color: '#FE2D8C'
        },
        deep: {
          color: '#FE2D8C'
        },
        shallow: {
          color: '#FE2D8C'
        },
        hover: {
          color: '#EE3B8C',
          p_10: {
            color: 'rgba(238, 59, 140, 0.1)'
          }
        },
        active: {
          color: '#DD3F87',
          p_20: {
            color: 'rgba(221, 63, 135, 0.2)'
          }
        },
        disabled: {
          color: '#FFA7CF'
        },
        inverted: {
          color: '#FFFFFF'
        },
        visited: {
          color: '#FE2D8C'
        }
      },
      tertiary: {
        default: {
          color: '#516FFF'
        },
        deep: {
          color: '#516FFF'
        },
        shallow: {
          color: '#516FFF'
        },
        hover: {
          color: '#3E5FFF',
          p_10: {
            color: 'rgba(61, 94, 255, 0.1)'
          }
        },
        active: {
          color: '#254BFF',
          p_20: {
            color: 'rgba(38, 74, 255, 0.1)'
          }
        },
        disabled: {
          color: '#8B9FFF'
        },
        inverted: {
          color: '#FFFFFF'
        },
        visited: {
          color: '#5E38BA'
        }
      },
      neutral: {
        default: {
          color: '#E0E6EE'
        },
        deep: {
          color: '#FEFEFE'
        },
        shallow: {
          color: '#D1D6DF'
        },
        hover: {
          color: '#D1DDED',
          p_10: {
            color: 'rgba(209, 221, 237, 0.1)'
          }
        },
        active: {
          color: '#C2D5ED',
          p_20: {
            color: 'rgba(194, 213, 237, 0.2)'
          }
        },
        disabled: {
          color: '#DBDBE1'
        },
        inverted: {
          color: '#5A6270'
        },
        visited: {
          color: '#E0E6EE'
        }
      }
    },
    states: {
      success: {
        color: '#2ECC71',
        inverted: {
          color: '#EDF9F0'
        },
        active: {
          color: '#2DE179'
        }
      },
      error: {
        color: '#D63031',
        inverted: {
          color: '#FEEFEF'
        },
        active: {
          color: '#EC4041'
        }
      },
      warning: {
        color: '#F39C12',
        inverted: {
          color: '#FFF4EC'
        },
        active: {
          color: '#FCAB2B'
        }
      },
      info: {
        color: '#3498DB',
        inverted: {
          color: '#EEF2FA'
        },
        active: {
          color: '#3FA9F0'
        }
      }
    }
  },
  dark: {
    base: {
      b_1: {
        color: '#212129'
      },
      b_2: {
        color: '#27282D'
      }
    },
    primary: {
      default: {
        color: '#A174FE'
      },
      p_90: {
        color: 'rgba(161, 116, 254, 0.9)'
      },
      p_80: {
        color: 'rgba(161, 116, 254, 0.8)'
      },
      p_70: {
        color: 'rgba(161, 116, 254, 0.7)'
      },
      p_60: {
        color: 'rgba(161, 116, 254, 0.6)'
      },
      p_50: {
        color: 'rgba(161, 116, 254, 0.5)'
      },
      p_40: {
        color: 'rgba(161, 116, 254, 0.4)'
      },
      p_30: {
        color: 'rgba(161, 116, 254, 0.3)'
      },
      p_20: {
        color: 'rgba(161, 116, 254, 0.2)'
      },
      p_10: {
        color: 'rgba(161, 116, 254, 0.1)'
      }
    },
    secondary: {
      default: {
        color: '#F51AAF'
      },
      p_90: {
        color: 'rgba(245, 26, 175, 0.9)'
      },
      p_80: {
        color: 'rgba(245, 26, 175, 0.8)'
      },
      p_70: {
        color: 'rgba(245, 26, 175, 0.7)'
      },
      p_60: {
        color: 'rgba(245, 26, 175, 0.6)'
      },
      p_50: {
        color: 'rgba(245, 26, 175, 0.5)'
      },
      p_40: {
        color: 'rgba(245, 26, 175, 0.4)'
      },
      p_30: {
        color: 'rgba(245, 26, 175, 0.3)'
      },
      p_20: {
        color: 'rgba(245, 26, 175, 0.2)'
      },
      p_10: {
        color: 'rgba(245, 26, 175, 0.1)'
      }
    },
    tertiary: {
      default: {
        color: '#516FFF'
      },
      p_90: {
        color: 'rgba(81, 111, 255, 0.9)'
      },
      p_80: {
        color: 'rgba(81, 111, 255, 0.8)'
      },
      p_70: {
        color: 'rgba(81, 111, 255, 0.7)'
      },
      p_60: {
        color: 'rgba(81, 111, 255, 0.6)'
      },
      p_50: {
        color: 'rgba(81, 111, 255, 0.5)'
      },
      p_40: {
        color: 'rgba(81, 111, 255, 0.4)'
      },
      p_30: {
        color: 'rgba(81, 111, 255, 0.3)'
      },
      p_20: {
        color: 'rgba(81, 111, 255, 0.2)'
      },
      p_10: {
        color: 'rgba(81, 111, 255, 0.1)'
      }
    },
    neutral: {
      n_1: {
        color: '#F6F6F6'
      },
      n_2: {
        color: '#6B7188'
      },
      n_3: {
        color: '#FFFFFF'
      },
      n_4: {
        color: '#9EA3B6'
      },
      n_5: {
        color: '#BEC2C8'
      },
      n_6: {
        color: '#68686C'
      },
      n_7: {
        color: '#696B73'
      },
      n_8: {
        color: '#8D8D8D'
      },
      n_9: {
        color: '#F4F4F5'
      },
      n_10: {
        color: '#464646'
      },
      white: {
        color: '#FFFFFF'
      },
      black: {
        color: '#000000'
      }
    },
    accents: {
      a_1: {
        default: {
          color: '#5797F8'
        },
        hover: {
          color: '#57B6F8'
        },
        active: {
          color: '#A2B7FF'
        },
        disabled: {
          color: '#9EC5FF'
        }
      },
      a_2: {
        default: {
          color: '#376AFE'
        },
        hover: {
          color: '#1B55FF'
        },
        active: {
          color: '#2E55C7'
        },
        disabled: {
          color: '#8AA8FF'
        }
      },
      a_3: {
        default: {
          color: '#F76294'
        },
        hover: {
          color: '#FF4785'
        },
        active: {
          color: '#EB3B76'
        },
        disabled: {
          color: '#FF8DB3'
        }
      },
      a_4: {
        default: {
          color: '#84EB86'
        },
        hover: {
          color: '#45F248'
        },
        active: {
          color: '#73C99F'
        },
        disabled: {
          color: '#9EEE9F'
        }
      },
      a_5: {
        default: {
          color: '#FFC500'
        },
        hover: {
          color: '#FFA200'
        },
        active: {
          color: '#FFB18D'
        },
        disabled: {
          color: '#FFDC65'
        }
      },
      a_6: {
        default: {
          color: '#E74B4B'
        },
        hover: {
          color: '#E86364'
        },
        active: {
          color: '#DF6167'
        },
        disabled: {
          color: '#F58181'
        }
      },
      a_7: {
        default: {
          color: '#FFCE6E'
        },
        hover: {
          color: '#FFC561'
        },
        active: {
          color: '#FAD372'
        },
        disabled: {
          color: '#FFDFA0'
        }
      }
    },
    actions: {
      primary: {
        default: {
          color: '#8A51FF'
        },
        deep: {
          color: '#8A51FF'
        },
        shallow: {
          color: '#8A51FF'
        },
        hover: {
          color: '#7A38FF',
          p_10: {
            color: 'rgba(122, 56, 255, 0.1)'
          }
        },
        active: {
          color: '#691FFF',
          p_20: {
            color: 'rgba(105, 31, 255, 0.2)'
          }
        },
        disabled: {
          color: '#CFB8FF'
        },
        inverted: {
          color: '#27282D'
        },
        visited: {
          color: '#5E38BA'
        }
      },
      secondary: {
        default: {
          color: '#E151FF'
        },
        deep: {
          color: '#E151FF'
        },
        shallow: {
          color: '#E151FF'
        },
        hover: {
          color: '#E04BFF',
          p_10: {
            color: 'rgba(244, 75, 255, 0.1)'
          }
        },
        active: {
          color: '#DB31FF',
          p_20: {
            color: 'rgba(219, 49, 255, 0.2)'
          }
        },
        disabled: {
          color: '#EF9FFF'
        },
        inverted: {
          color: '#FFFFFF'
        },
        visited: {
          color: '#5E38BA'
        }
      },
      tertiary: {
        default: {
          color: '#516FFF'
        },
        deep: {
          color: '#516FFF'
        },
        shallow: {
          color: '#516FFF'
        },
        hover: {
          color: '#3E5FFF',
          p_10: {
            color: 'rgba(62, 95, 255, 0.1)'
          }
        },
        active: {
          color: '#254BFF',
          p_20: {
            color: 'rgba(37, 75, 255, 0.2)'
          }
        },
        disabled: {
          color: '#8B9FFF'
        },
        inverted: {
          color: '#FFFFFF'
        },
        visited: {
          color: '#5E38BA'
        }
      },
      neutral: {
        default: {
          color: '#898B8E'
        },
        deep: {
          color: '#6D7077'
        },
        shallow: {
          color: '#ADB1B9'
        },
        hover: {
          color: '#999C9F',
          p_10: {
            color: 'rgba(153, 156, 159, 0.1)'
          }
        },
        active: {
          color: '#7A7C7E',
          p_20: {
            color: 'rgba(122, 124, 126, 0.2)'
          }
        },
        disabled: {
          color: '#C6C7C9'
        },
        inverted: {
          color: '#FFFFFF'
        },
        visited: {
          color: '#5E38BA'
        }
      }
    },
    states: {
      success: {
        color: '#2ECC71',
        inverted: {
          color: '#EDF9F0'
        },
        active: {
          color: '#2DE179'
        }
      },
      error: {
        color: '#D63031',
        inverted: {
          color: '#FEEFEF'
        },
        active: {
          color: '#EC4041'
        }
      },
      warning: {
        color: '#F39C12',
        inverted: {
          color: '#FFF4EC'
        },
        active: {
          color: '#FCAB2B'
        }
      },
      info: {
        color: '#3498DB',
        inverted: {
          color: '#EEF2FA'
        },
        active: {
          color: '#3FA9F0'
        }
      }
    }
  }
});
export default Colors;
export let ColorSchemes = /*#__PURE__*/function (ColorSchemes) {
  ColorSchemes["LIGHT"] = "light";
  ColorSchemes["DARK"] = "dark";
  return ColorSchemes;
}({});